// Constantes para el formulario de partidas presupuestarias

export const formBudgetItemManagementNaming = {
  NEW_BUDGET_ITEM_MANAGEMENT_FORM: 'NEW_BUDGET_ITEM_MANAGEMENT_FORM',
};

// Valores por defecto para el formulario
export const defaultBudgetItemValues = {
  code: '',
  description: '',
  unit: 'u',
  unitPrice: 0,
  budgetCategoryId: '',
  isActive: true,
  isCreated: true,
  id: '',
};

// Unidades comunes para las partidas
export const COMMON_UNITS = [
  { value: 'u', label: 'Unidad (u)' },
  { value: 'm', label: 'Metro (m)' },
  { value: 'm²', label: 'Metro cuadrado (m²)' },
  { value: 'm³', label: 'Metro cúbico (m³)' },
  { value: 'Km', label: 'Kilómetro (Km)' },
  { value: 'Hm²', label: 'Hectómetro cuadrado (Hm²)' },
  { value: 'h', label: 'Hora (h)' },
  { value: 'P.A.', label: 'Partida alzada (P.A.)' },
  { value: 'kg', label: 'Kilogramo (kg)' },
  { value: 't', label: 'Tonelada (t)' },
  { value: 'l', label: 'Litro (l)' },
];

